import React from 'react';
import { isNumeric, createCustomPropType } from '../../js/app/react/validators';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';

const AllWorkflowsDoneView = ({ clientId }) => {
  useDocumentTitle('Workflow Done');

  return (
    <div id="AllWorkflowsDone">
      <div className="image" />

      <div className="header">
        <h2>You&apos;re done!</h2>
      </div>

      <p>
        Your financial plan is being prepared. You will be notified by email after it has been
        reviewed.
      </p>

      <button
        type="button"
        id="btn-continue"
        className="secondary flat"
        onClick={() => window.ADV.util.Router.go2('ClientStartPage', { clientId })}
      >
        Continue making changes
      </button>
    </div>
  );
};

AllWorkflowsDoneView.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
};

export default AllWorkflowsDoneView;
